import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import CircularProgress from '@mui/material/CircularProgress';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useContext(AuthContext);

    const location = useLocation();

    if (loading) {
        return (
            <div style={{ textAlign: 'center', margin: '20px auto' }}>
                <CircularProgress />
            </div>
        ); // Show loading spinner while checking access permission
    }

    if (!isAuthenticated) {
        return <Navigate to={`/login?redirect=${location.pathname}`} />; // Redirect to login in case not authenticated
    }

    return children; // Renderiza la ruta protegida si está autenticado
};

export default ProtectedRoute;
